export function setLocations(state, payload) {
  state.all = payload;
}

export function updateCurrentLocation(state, payload) {
  state.current = payload;
}

export function setDeliveryMethods(state, payload) {
  state.deliveryMethods = payload;
}
